import { addLocaleData } from 'react-intl'
import LocaleConstants from 'constants/LocaleConstants'

class LocaleActions extends Marty.ActionCreators {
  loadLocale(locale) {
    return new Promise((resolve) => {
      if (!Intl) {
        switch (locale) {
          case 'en':
            require.ensure([
              'intl/locale-data/jsonp/en.js',
              'react-intl/locale-data/en.js',
            ], (require) => {
              require('intl/locale-data/jsonp/en.js')
              addLocaleData([...require('react-intl/locale-data/en.js')])
              this.dispatch(LocaleConstants.LOCALE_LOADED, locale)
              resolve()
            })
            break
          case 'es':
            require.ensure([
              'intl/locale-data/jsonp/es.js',
              'react-intl/locale-data/es.js',
            ], (require) => {
              require('intl/locale-data/jsonp/es.js')
              addLocaleData([...require('react-intl/locale-data/es.js')])
              this.dispatch(LocaleConstants.LOCALE_LOADED, locale)
              resolve()
            })
            break
          case 'et':
            require.ensure([
              'intl/locale-data/jsonp/et.js',
              'react-intl/locale-data/et.js',
            ], (require) => {
              require('intl/locale-data/jsonp/et.js')
              addLocaleData([...require('react-intl/locale-data/et.js')])
              this.dispatch(LocaleConstants.LOCALE_LOADED, locale)
              resolve()
            })
            break
          case 'de':
          case 'de-DE':
          case 'de-DE-formal':
            require.ensure([
              'intl/locale-data/jsonp/de.js',
              'react-intl/locale-data/de.js',
            ], (require) => {
              require('intl/locale-data/jsonp/de.js')
              addLocaleData([...require('react-intl/locale-data/de.js')])
              this.dispatch(LocaleConstants.LOCALE_LOADED, locale)
              resolve()
            })
            break
          case 'hi':
            require.ensure([
              'intl/locale-data/jsonp/hi.js',
              'react-intl/locale-data/hi.js',
            ], (require) => {
              require('intl/locale-data/jsonp/hi.js')
              addLocaleData([...require('react-intl/locale-data/hi.js')])
              this.dispatch(LocaleConstants.LOCALE_LOADED, locale)
              resolve()
            })
            break
          case 'nl':
            require.ensure([
              'intl/locale-data/jsonp/nl.js',
              'react-intl/locale-data/nl.js',
            ], (require) => {
              require('intl/locale-data/jsonp/nl.js')
              addLocaleData([...require('react-intl/locale-data/nl.js')])
              this.dispatch(LocaleConstants.LOCALE_LOADED, locale)
              resolve()
            })
            break
          case 'pt':
          case 'pt-PT':
          case 'pt-BR':
            require.ensure([
              'intl/locale-data/jsonp/pt.js',
              'react-intl/locale-data/pt.js',
            ], (require) => {
              require('intl/locale-data/jsonp/pt.js')
              addLocaleData([...require('react-intl/locale-data/pt.js')])
              this.dispatch(LocaleConstants.LOCALE_LOADED, locale)
              resolve()
            })
            break
          case 'sv':
            require.ensure([
              'intl/locale-data/jsonp/sv.js',
              'react-intl/locale-data/sv.js',
            ], (require) => {
              require('intl/locale-data/jsonp/sv.js')
              addLocaleData([...require('react-intl/locale-data/sv.js')])
              this.dispatch(LocaleConstants.LOCALE_LOADED, locale)
              resolve()
            })
            break
          case 'zh':
            require.ensure([
              'intl/locale-data/jsonp/zh.js',
              'react-intl/locale-data/zh.js',
            ], (require) => {
              require('intl/locale-data/jsonp/zh.js')
              addLocaleData([...require('react-intl/locale-data/zh.js')])
              this.dispatch(LocaleConstants.LOCALE_LOADED, locale)
              resolve()
            })
            break
          case 'fr':
            require.ensure([
              'intl/locale-data/jsonp/fr.js',
              'react-intl/locale-data/fr.js',
            ], (require) => {
              require('intl/locale-data/jsonp/fr.js')
              addLocaleData([...require('react-intl/locale-data/fr.js')])
              this.dispatch(LocaleConstants.LOCALE_LOADED, locale)
              resolve()
            })
            break
          case 'it':
            require.ensure([
              'intl/locale-data/jsonp/it.js',
              'react-intl/locale-data/it.js',
            ], (require) => {
              require('intl/locale-data/jsonp/it.js')
              addLocaleData([...require('react-intl/locale-data/it.js')])
              this.dispatch(LocaleConstants.LOCALE_LOADED, locale)
              resolve()
            })
            break
          case 'tr':
            require.ensure([
              'intl/locale-data/jsonp/tr.js',
              'react-intl/locale-data/tr.js',
            ], (require) => {
              require('intl/locale-data/jsonp/tr.js')
              addLocaleData([...require('react-intl/locale-data/tr.js')])
              this.dispatch(LocaleConstants.LOCALE_LOADED, locale)
              resolve()
            })
            break
          case 'ru':
            require.ensure([
              'intl/locale-data/jsonp/ru.js',
              'react-intl/locale-data/ru.js',
            ], (require) => {
              require('intl/locale-data/jsonp/ru.js')
              addLocaleData([...require('react-intl/locale-data/ru.js')])
              this.dispatch(LocaleConstants.LOCALE_LOADED, locale)
              resolve()
            })
            break
          case 'pl':
            require.ensure([
              'intl/locale-data/jsonp/pl.js',
              'react-intl/locale-data/pl.js',
            ], (require) => {
              require('intl/locale-data/jsonp/pl.js')
              addLocaleData([...require('react-intl/locale-data/pl.js')])
              this.dispatch(LocaleConstants.LOCALE_LOADED, locale)
              resolve()
            })
            break
          case 'sl':
            require.ensure([
              'intl/locale-data/jsonp/sl.js',
              'react-intl/locale-data/sl.js',
            ], (require) => {
              require('intl/locale-data/jsonp/sl.js')
              addLocaleData([...require('react-intl/locale-data/sl.js')])
              this.dispatch(LocaleConstants.LOCALE_LOADED, locale)
              resolve()
            })
            break
          case 'da':
            require.ensure([
              'intl/locale-data/jsonp/da.js',
              'react-intl/locale-data/da.js',
            ], (require) => {
              require('intl/locale-data/jsonp/da.js')
              addLocaleData([...require('react-intl/locale-data/da.js')])
              this.dispatch(LocaleConstants.LOCALE_LOADED, locale)
              resolve()
            })
            break
          case 'fi':
            require.ensure([
              'intl/locale-data/jsonp/fi.js',
              'react-intl/locale-data/fi.js',
            ], (require) => {
              require('intl/locale-data/jsonp/fi.js')
              addLocaleData([...require('react-intl/locale-data/fi.js')])
              this.dispatch(LocaleConstants.LOCALE_LOADED, locale)
              resolve()
            })
            break
          case 'hr':
            require.ensure([
              'intl/locale-data/jsonp/hr.js',
              'react-intl/locale-data/hr.js',
            ], (require) => {
              require('intl/locale-data/jsonp/hr.js')
              addLocaleData([...require('react-intl/locale-data/hr.js')])
              this.dispatch(LocaleConstants.LOCALE_LOADED, locale)
              resolve()
            })
            break
          case 'ko':
            require.ensure([
              'intl/locale-data/jsonp/ko.js',
              'react-intl/locale-data/ko.js',
            ], (require) => {
              require('intl/locale-data/jsonp/ko.js')
              addLocaleData([...require('react-intl/locale-data/ko.js')])
              this.dispatch(LocaleConstants.LOCALE_LOADED, locale)
              resolve()
            })
            break
          case 'nb':
            require.ensure([
              'intl/locale-data/jsonp/nb.js',
              'react-intl/locale-data/nb.js',
            ], (require) => {
              require('intl/locale-data/jsonp/nb.js')
              addLocaleData([...require('react-intl/locale-data/nb.js')])
              this.dispatch(LocaleConstants.LOCALE_LOADED, locale)
              resolve()
            })
            break
          case 'ro':
            require.ensure([
              'intl/locale-data/jsonp/ro.js',
              'react-intl/locale-data/ro.js',
            ], (require) => {
              require('intl/locale-data/jsonp/ro.js')
              addLocaleData([...require('react-intl/locale-data/ro.js')])
              this.dispatch(LocaleConstants.LOCALE_LOADED, locale)
              resolve()
            })
            break
          case 'sr':
            require.ensure([
              'intl/locale-data/jsonp/sr.js',
              'react-intl/locale-data/sr.js',
            ], (require) => {
              require('intl/locale-data/jsonp/sr.js')
              addLocaleData([...require('react-intl/locale-data/sr.js')])
              this.dispatch(LocaleConstants.LOCALE_LOADED, locale)
              resolve()
            })
            break
          case 'th':
            require.ensure([
              'intl/locale-data/jsonp/th.js',
              'react-intl/locale-data/th.js',
            ], (require) => {
              require('intl/locale-data/jsonp/th.js')
              addLocaleData([...require('react-intl/locale-data/th.js')])
              this.dispatch(LocaleConstants.LOCALE_LOADED, locale)
              resolve()
            })
            break
          case 'vi':
            require.ensure([
              'intl/locale-data/jsonp/vi.js',
              'react-intl/locale-data/vi.js',
            ], (require) => {
              require('intl/locale-data/jsonp/vi.js')
              addLocaleData([...require('react-intl/locale-data/vi.js')])
              this.dispatch(LocaleConstants.LOCALE_LOADED, locale)
              resolve()
            })
            break
          case 'hu':
            require.ensure([
              'intl/locale-data/jsonp/hu.js',
              'react-intl/locale-data/hu.js',
            ], (require) => {
              require('intl/locale-data/jsonp/hu.js')
              addLocaleData([...require('react-intl/locale-data/hu.js')])
              this.dispatch(LocaleConstants.LOCALE_LOADED, locale)
              resolve()
            })
            break
          case 'is':
            require.ensure([
              'intl/locale-data/jsonp/is.js',
              'react-intl/locale-data/is.js',
            ], (require) => {
              require('intl/locale-data/jsonp/is.js')
              addLocaleData([...require('react-intl/locale-data/is.js')])
              this.dispatch(LocaleConstants.LOCALE_LOADED, locale)
              resolve()
            })
            break
          case 'ja':
            require.ensure([
              'intl/locale-data/jsonp/ja-JP.js',
              'react-intl/locale-data/ja.js',
            ], (require) => {
              require('intl/locale-data/jsonp/ja-JP.js')
              addLocaleData([...require('react-intl/locale-data/ja.js')])
              this.dispatch(LocaleConstants.LOCALE_LOADED, locale)
              resolve()
            })
            break
          case 'ka':
            require.ensure([
              'intl/locale-data/jsonp/ka-GE.js',
              'react-intl/locale-data/ka.js',
            ], (require) => {
              require('intl/locale-data/jsonp/ka-GE.js')
              addLocaleData([...require('react-intl/locale-data/ka.js')])
              this.dispatch(LocaleConstants.LOCALE_LOADED, locale)
              resolve()
            })
            break
          default:
            require.ensure([
              'intl/locale-data/jsonp/en.js',
              'react-intl/locale-data/en.js',
            ], (require) => {
              require('intl/locale-data/jsonp/en.js')
              addLocaleData([...require('react-intl/locale-data/en.js')])
              this.dispatch(LocaleConstants.LOCALE_LOADED, locale)
              resolve()
            })
            break
        }
      } else {
        switch (locale) {
          case 'en':
            require.ensure([
              'react-intl/locale-data/en.js',
            ], (require) => {
              addLocaleData([...require('react-intl/locale-data/en.js')])
              this.dispatch(LocaleConstants.LOCALE_LOADED, locale)
              resolve()
            })
            break
          case 'es':
            require.ensure([
              'react-intl/locale-data/es.js',
            ], (require) => {
              addLocaleData([...require('react-intl/locale-data/es.js')])
              this.dispatch(LocaleConstants.LOCALE_LOADED, locale)
              resolve()
            })
            break
          case 'et':
            require.ensure([
              'react-intl/locale-data/et.js',
            ], (require) => {
              addLocaleData([...require('react-intl/locale-data/et.js')])
              this.dispatch(LocaleConstants.LOCALE_LOADED, locale)
              resolve()
            })
            break
          case 'de':
          case 'de-DE':
          case 'de-DE-formal':
            require.ensure([
              'react-intl/locale-data/de.js',
            ], (require) => {
              addLocaleData([...require('react-intl/locale-data/de.js')])
              this.dispatch(LocaleConstants.LOCALE_LOADED, locale)
              resolve()
            })
            break
          case 'hi':
            require.ensure([
              'react-intl/locale-data/hi.js',
            ], (require) => {
              addLocaleData([...require('react-intl/locale-data/hi.js')])
              this.dispatch(LocaleConstants.LOCALE_LOADED, locale)
              resolve()
            })
            break
          case 'nl':
            require.ensure([
              'react-intl/locale-data/nl.js',
            ], (require) => {
              addLocaleData([...require('react-intl/locale-data/nl.js')])
              this.dispatch(LocaleConstants.LOCALE_LOADED, locale)
              resolve()
            })
            break
          case 'pt':
          case 'pt-PT':
          case 'pt-BR':
            require.ensure([
              'react-intl/locale-data/pt.js',
            ], (require) => {
              addLocaleData([...require('react-intl/locale-data/pt.js')])
              this.dispatch(LocaleConstants.LOCALE_LOADED, locale)
              resolve()
            })
            break
          case 'sv':
            require.ensure([
              'react-intl/locale-data/sv.js',
            ], (require) => {
              addLocaleData([...require('react-intl/locale-data/sv.js')])
              this.dispatch(LocaleConstants.LOCALE_LOADED, locale)
              resolve()
            })
            break
          case 'zh':
            require.ensure([
              'react-intl/locale-data/zh.js',
            ], (require) => {
              addLocaleData([...require('react-intl/locale-data/zh.js')])
              this.dispatch(LocaleConstants.LOCALE_LOADED, locale)
              resolve()
            })
            break
          case 'fr':
            require.ensure([
              'react-intl/locale-data/fr.js',
            ], (require) => {
              addLocaleData([...require('react-intl/locale-data/fr.js')])
              this.dispatch(LocaleConstants.LOCALE_LOADED, locale)
              resolve()
            })
            break
          case 'it':
            require.ensure([
              'react-intl/locale-data/it.js',
            ], (require) => {
              addLocaleData([...require('react-intl/locale-data/it.js')])
              this.dispatch(LocaleConstants.LOCALE_LOADED, locale)
              resolve()
            })
            break
          case 'tr':
            require.ensure([
              'react-intl/locale-data/tr.js',
            ], (require) => {
              addLocaleData([...require('react-intl/locale-data/tr.js')])
              this.dispatch(LocaleConstants.LOCALE_LOADED, locale)
              resolve()
            })
            break
          case 'ru':
            require.ensure([
              'react-intl/locale-data/ru.js',
            ], (require) => {
              addLocaleData([...require('react-intl/locale-data/ru.js')])
              this.dispatch(LocaleConstants.LOCALE_LOADED, locale)
              resolve()
            })
            break
          case 'pl':
            require.ensure([
              'react-intl/locale-data/pl.js',
            ], (require) => {
              addLocaleData([...require('react-intl/locale-data/pl.js')])
              this.dispatch(LocaleConstants.LOCALE_LOADED, locale)
              resolve()
            })
            break
          case 'sl':
            require.ensure([
              'react-intl/locale-data/sl.js',
            ], (require) => {
              addLocaleData([...require('react-intl/locale-data/sl.js')])
              this.dispatch(LocaleConstants.LOCALE_LOADED, locale)
              resolve()
            })
            break
          case 'da':
            require.ensure([
              'react-intl/locale-data/da.js',
            ], (require) => {
              addLocaleData([...require('react-intl/locale-data/da.js')])
              this.dispatch(LocaleConstants.LOCALE_LOADED, locale)
              resolve()
            })
            break
          case 'fi':
            require.ensure([
              'react-intl/locale-data/fi.js',
            ], (require) => {
              addLocaleData([...require('react-intl/locale-data/fi.js')])
              this.dispatch(LocaleConstants.LOCALE_LOADED, locale)
              resolve()
            })
            break
          case 'hr':
            require.ensure([
              'react-intl/locale-data/hr.js',
            ], (require) => {
              addLocaleData([...require('react-intl/locale-data/hr.js')])
              this.dispatch(LocaleConstants.LOCALE_LOADED, locale)
              resolve()
            })
            break
          case 'ko':
            require.ensure([
              'react-intl/locale-data/ko.js',
            ], (require) => {
              addLocaleData([...require('react-intl/locale-data/ko.js')])
              this.dispatch(LocaleConstants.LOCALE_LOADED, locale)
              resolve()
            })
            break
          case 'nb':
            require.ensure([
              'react-intl/locale-data/nb.js',
            ], (require) => {
              addLocaleData([...require('react-intl/locale-data/nb.js')])
              this.dispatch(LocaleConstants.LOCALE_LOADED, locale)
              resolve()
            })
            break
          case 'ro':
            require.ensure([
              'react-intl/locale-data/ro.js',
            ], (require) => {
              addLocaleData([...require('react-intl/locale-data/ro.js')])
              this.dispatch(LocaleConstants.LOCALE_LOADED, locale)
              resolve()
            })
            break
          case 'sr':
            require.ensure([
              'react-intl/locale-data/sr.js',
            ], (require) => {
              addLocaleData([...require('react-intl/locale-data/sr.js')])
              this.dispatch(LocaleConstants.LOCALE_LOADED, locale)
              resolve()
            })
            break
          case 'th':
            require.ensure([
              'react-intl/locale-data/th.js',
            ], (require) => {
              addLocaleData([...require('react-intl/locale-data/th.js')])
              this.dispatch(LocaleConstants.LOCALE_LOADED, locale)
              resolve()
            })
            break
          case 'vi':
            require.ensure([
              'react-intl/locale-data/vi.js',
            ], (require) => {
              addLocaleData([...require('react-intl/locale-data/vi.js')])
              this.dispatch(LocaleConstants.LOCALE_LOADED, locale)
              resolve()
            })
            break
          case 'hu':
            require.ensure([
              'react-intl/locale-data/hu.js',
            ], (require) => {
              addLocaleData([...require('react-intl/locale-data/hu.js')])
              this.dispatch(LocaleConstants.LOCALE_LOADED, locale)
              resolve()
            })
            break
          case 'is':
            require.ensure([
              'react-intl/locale-data/is.js',
            ], (require) => {
              addLocaleData([...require('react-intl/locale-data/is.js')])
              this.dispatch(LocaleConstants.LOCALE_LOADED, locale)
              resolve()
            })
            break
          case 'ja':
            require.ensure([
              'react-intl/locale-data/ja.js',
            ], (require) => {
              addLocaleData([...require('react-intl/locale-data/ja.js')])
              this.dispatch(LocaleConstants.LOCALE_LOADED, locale)
              resolve()
            })
            break
          case 'ka':
            require.ensure([
              'react-intl/locale-data/ka.js',
            ], (require) => {
              addLocaleData([...require('react-intl/locale-data/ka.js')])
              this.dispatch(LocaleConstants.LOCALE_LOADED, locale)
              resolve()
            })
            break
          default:
            require.ensure([
              'react-intl/locale-data/en.js',
            ], (require) => {
              addLocaleData([...require('react-intl/locale-data/en.js')])
              this.dispatch(LocaleConstants.LOCALE_LOADED, locale)
              resolve()
            })
            break
        }
      }
    })
  }
}

export default LocaleActions



// WEBPACK FOOTER //
// ./src/scripts/actions/LocaleActions.js